/**
 * Applies Regios customer-segment discounts to product cards.
 *
 * Relies on window.RegiosDOPP.api.v0 injected by the "Discounts Embed" app block.
 *
 * Required card attributes:
 *   data-regios-dopp-generic-product-id — numeric product ID on the card wrapper
 *   data-variant-id                     — numeric variant ID on the card wrapper
 *
 * Required price element classes (from jkl-pdp-price.liquid):
 *   .regios-dopp-generic-price-container
 *   .regios-dopp-generic-price-item--sale
 *   .regios-dopp-generic-price-item--regular
 *   .regios-dopp-generic-badge  (optional)
 *   [data-regios-card-badge]            — image overlay badge (optional)
 */
(function () {
  'use strict';

  // Global API reference — set once when Regios initialises
  if (!window.jklRegiosCollection) {
    window.jklRegiosCollection = { api: null };
  }

  function applyToCards(cards) {
    var api = window.jklRegiosCollection.api;
    if (!api || !cards.length) return;

    Array.from(cards).forEach(function (card) {
      if (card.dataset.regiosApplied) return;
      card.dataset.regiosApplied = '1';

      var productId = parseInt(card.dataset.regiosDoppGenericProductId, 10);
      var variantId = parseInt(card.dataset.variantId, 10);
      if (!productId || !variantId) return;

      var container = card.querySelector('.regios-dopp-generic-price-container');
      var saleEl    = container && container.querySelector('.regios-dopp-generic-price-item--sale');
      var regularEl = container && container.querySelector('.regios-dopp-generic-price-item--regular');
      if (!container || !saleEl || !regularEl) return;

      var priceText    = saleEl.textContent.trim().replace(/[^\d,.]/g, '').replace(',', '.');
      var priceInCents = Math.round(parseFloat(priceText) * 100) || 0;

      api.calculateDiscountedPrices({
        productId: productId,
        variantId: variantId,
        regularPriceInCents: priceInCents,
        compareAtPriceInCents: undefined,
      }).then(function (result) {
        if (!result || !result.salePrice || result.salePrice.amount >= result.regularPrice.amount) return;

        saleEl.textContent    = result.salePrice.formatted;
        regularEl.textContent = result.regularPrice.formatted;
        regularEl.classList.remove('hidden');
        container.classList.add('jkl-pdp-price--on-sale');

        var pct = Math.round((1 - result.salePrice.amount / result.regularPrice.amount) * 100);

        var badgeEl = container.querySelector('.regios-dopp-generic-badge');
        if (badgeEl && badgeEl.classList.contains('hidden')) {
          // Only show price-row badge if it wasn't deliberately hidden (show_discount:false for cards)
          // Leave hidden for cards — image overlay badge handles it
        }

        var cardBadge = card.querySelector('[data-regios-card-badge]');
        if (cardBadge) {
          cardBadge.textContent = '-' + pct + '%';
          cardBadge.classList.remove('hidden');
        }

        var descEl = container.querySelector('.regios-dopp-description');
        if (descEl && result.description && result.description.html) {
          descEl.innerHTML = result.description.html;
          if (result.description.css) descEl.style.cssText = result.description.css;
          descEl.classList.remove('hidden');
        }
      }).catch(function () {});
    });
  }

  function applyAll() {
    applyToCards(document.querySelectorAll('[data-regios-dopp-generic-product-id]:not([data-regios-applied])'));
  }

  function init(api) {
    window.jklRegiosCollection.api = api;
    applyAll();
  }

  // Re-apply after Load More appends new products
  document.addEventListener('jkl:products-loaded', applyAll);

  if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
    init(window.RegiosDOPP.api.v0);
  } else {
    window.addEventListener('regios-dopp:api-initialized', function (e) {
      init(e.detail ? e.detail.api : window.RegiosDOPP.api.v0);
    });
  }
})();
